import React, { useState } from "react";
import { useAdminAuth, formatApiError } from "@/admin/AdminAuthContext";
import { Loader2 } from "lucide-react";

export const AdminLogin = () => {
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-screen"
      className="min-h-screen bg-[#F8F5F0] text-[#2C302E] flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <a
          href="/"
          className="text-xs uppercase tracking-[0.28em] text-[#8A9A86] font-semibold hover:text-[#C05C3D] transition-colors"
        >
          ← Villa Sućuraj
        </a>
        <h1 className="mt-6 font-serif font-light text-4xl md:text-5xl tracking-tight">
          Admin
        </h1>
        <p className="mt-3 text-sm text-[#5C625E] font-light">
          Sign in to manage bookings and availability.
        </p>

        <form onSubmit={onSubmit} className="mt-12 space-y-8">
          <div>
            <label
              htmlFor="admin-email"
              className="text-xs uppercase tracking-[0.22em] text-[#5C625E] font-semibold"
            >
              Email
            </label>
            <input
              id="admin-email"
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              className="mt-2 w-full bg-transparent border-0 border-b border-[#2C302E]/30 px-0 py-2 text-base text-[#2C302E] focus:outline-none focus:border-[#C05C3D] transition-colors"
            />
          </div>
          <div>
            <label
              htmlFor="admin-password"
              className="text-xs uppercase tracking-[0.22em] text-[#5C625E] font-semibold"
            >
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              className="mt-2 w-full bg-transparent border-0 border-b border-[#2C302E]/30 px-0 py-2 text-base text-[#2C302E] focus:outline-none focus:border-[#C05C3D] transition-colors"
            />
          </div>

          {error && (
            <div
              data-testid="admin-login-error"
              className="text-sm text-[#C05C3D] border-l-2 border-[#C05C3D] pl-3 py-1"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="inline-flex items-center justify-center gap-3 bg-[#C05C3D] hover:bg-[#a64c30] disabled:opacity-60 text-[#F8F5F0] px-10 py-4 text-xs uppercase tracking-[0.22em] font-semibold transition-colors min-w-[220px]"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                Signing in…
              </>
            ) : (
              <>
                Sign in
                <span className="inline-block w-6 h-px bg-current" />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};
